export default ["576px", "1040px"];
